import { z } from '@harvestiq/zod';

export const downloadClaimPacketParamsSchema = z.object({
  claimId: z.string().uuid(),
});

export type DownloadClaimPacketParams = z.infer<
  typeof downloadClaimPacketParamsSchema
>;

export const downloadClaimPacketResponseSchema = z.object({
  data: z
    .object({
      claimPacketDownloadUrl: z.string(),
      claimPacketName: z.string(),
    })
    .optional(),
  error: z.string().optional(),
});

export type DownloadClaimPacketResponse = z.infer<
  typeof downloadClaimPacketResponseSchema
>;
